<template>
  <div>
    <AppAutocomplete v-model="searchValue"
                     :items="items"
                     v-model:search-input="searchInput"
                     return-object
                     item-value="id"
                     item-title="fullName"
                     :item-props="true"
                     :filter="memberAutocompleteFilter"
                     :placeholder="placeholder"
                     :hide-details="hideDetails"
                     clearable
                     clear-icon="fal fa-xmark"
                     color="grey"
                     data-locator="members-search-input"
                     @update:modelValue="onChange"
    >
      <template #prepend-inner>
        <app-icon-ds icon="magnifying-glass" size="xs" class="mr-2" />
      </template>
      <template #item="props">
        <v-list-item v-bind="props">
          <template #title>
            <v-avatar size="32" class="mr-2">
              {{ props.initials }}
            </v-avatar>
            {{ props.fullName }}
          </template>
        </v-list-item>
      </template>
    </AppAutocomplete>
  </div>
</template>

<script>
import AppAutocomplete from '@/common/AppAutocomplete.vue'
import i18n from '@/plugins/i18n'

function memberAutocompleteFilter (member, queryText) {
  return member.fullName.toLocaleLowerCase().includes(queryText.toLocaleLowerCase())
}

export default {
  name: 'MembersAutocomplete',
  components: { AppAutocomplete },
  data () {
    return {
      memberAutocompleteFilter,
      searchInput: '',
      searchValue: null,
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: i18n.global.t('project.members.MembersAutocomplete.placeholder'),
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange (member) {
      this.$emit('select', member)

      this.$nextTick(() => {
        this.searchInput = ''
        this.searchValue = null
      })
    },
  },
}
</script>

<style scoped lang="scss">
  :deep(.v-avatar) {
    background: rgb(var(--v-theme-grey-lighten-5));
    border: 1px solid rgb(var(--v-theme-grey-lighten-4));
    color: rgb(var(--v-theme-grey-600));
    font-weight: bold;
  }
  :deep(.v-field__append-inner .v-icon) {
    color: rgb(var(--v-theme-grey-600)) !important;
    opacity: 1;
  }
</style>
